import { injectable } from 'tsyringe';
import { MataPelajaranApiRepository } from '../../app/repository/api/MataPelajaranApiRepository';
import { MataPelajaran } from '../../entities/MataPelajaran';

@injectable()
export class MataPelajaranPresenter {
  private repository: MataPelajaranApiRepository;

  constructor(repository: MataPelajaranApiRepository) {
    this.repository = repository;
  }

  public getAllMataPelajaran(jenjang: string): Promise<MataPelajaran[]> {
    return this.repository.getAllMataPelajaran(jenjang);
  }
}
